import { Groupbutton, ModalContainer } from './styles';

import Layer from 'services/models/Layer';
import Coordinate from 'services/utils/Coordinate';

import BlueMarker from './assets/blue-marker.svg';
import DarkBlueMarker from './assets/dark-blue-marker.svg';
import OrangeMarker from './assets/orange-marker.svg';

import AttributeTable from '../../../../AttributeTable';
import ButtonTooltip from '../../ButtonTooltip';
import {
  typeOptions,
  timezoneOptions,
} from '../../Drawing/DrawByCoords/services/sridList';
import toolOptionsReducer, {
  initialToolOptionsState,
} from '../../Drawing/DrawByCoords/services/toolOptionsReducer';

/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
// import CustomModal from 'views/MapView/components/CustomModal';
import {CustomModalSaveAsLayer} from 'views/MapView/components/CustomModalSaveAsLayer';
import useSaveAsLayer from 'views/MapView/services/utils/saverAsLayer';


import {
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
} from '@material-ui/core';
import SelectMui from '@material-ui/core/Select';
import * as turf from '@turf/turf';
/**
 * Importação da biblioteca axios para fazer requisições baseadas em Promises.
 */
import axios from 'axios';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import CustomDraggable from 'components/ModalDraggable';
import { useFormik } from 'formik';
import L from 'leaflet';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 *
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 *
 * useCallback é um hook que retorna uma função de retorno
 * de chamada memorizada
 */
import { useState, useEffect, useCallback, useReducer } from 'react';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
import MaskedTextField from 'views/AdmView/components/Form/components/MaskedTextField';
import SliderColorPicker from 'views/MapView/components/SliderColorPicker';
// import SimpleModal from 'views/MapView/components/SimpleModal';
// import SliderColorPicker from 'views/MapView/components/SliderColorPicker';
import { useMap } from 'views/MapView/hooks';
import * as Yup from 'yup';

const Icon = (props) => (
  <svg
    width="21"
    height="19"
    viewBox="0 0 21 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3016 7.4972C12.5679 7.1906 12.5352 6.72619 12.2286 6.45992C11.922 6.19365 11.4576 6.22635 11.1913 6.53296L9.23084 8.79042L7.27093 6.53362C7.00466 6.22701 6.54025 6.19432 6.23364 6.46058C5.92704 6.72685 5.89434 7.19126 6.16061 7.49787L8.25698 9.9118L6.16088 12.3254C5.89461 12.632 5.92731 13.0964 6.23391 13.3627C6.54052 13.629 7.00493 13.5963 7.2712 13.2897L9.23084 11.0332L11.1911 13.2903C11.4573 13.5969 11.9217 13.6296 12.2283 13.3634C12.5349 13.0971 12.5676 12.6327 12.3014 12.3261L10.2047 9.9118L12.3016 7.4972ZM19.8361 8.40855C20.2033 8.58201 20.3603 9.02028 20.1869 9.38746L16.2962 17.6232C16.1227 17.9904 15.6845 18.1474 15.3173 17.974C14.9501 17.8005 14.7931 17.3622 14.9665 16.995L15.8945 15.0307L13.3548 9.37501C13.1884 9.00456 13.3539 8.5694 13.7243 8.40305C14.0948 8.2367 14.53 8.40215 14.6963 8.7726L16.721 13.2813L18.8572 8.7593C19.0307 8.39212 19.469 8.23509 19.8361 8.40855Z"
      fill="#BEC7DC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7171 3.23188C10.2263 0.741032 6.19347 0.741033 3.70263 3.23188C1.2355 5.699 1.21178 9.70807 3.65518 12.1989L8.19801 16.7417L10.0533 14.8864C10.381 15.1585 10.7866 15.3399 11.2317 15.3924L8.20987 18.4142L2.8249 13.0292C-0.0810852 10.0758 -0.0573632 5.3313 2.87234 2.4016C5.82578 -0.551834 10.594 -0.551834 13.5474 2.4016C14.8761 3.73025 15.6047 5.43389 15.7335 7.1751C15.4073 6.80002 14.9599 6.53326 14.4522 6.43594C14.206 5.23061 13.6091 4.12391 12.7171 3.23188Z"
      fill="#BEC7DC"
    />
  </svg>
);

const IconClose = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      y1="-0.75"
      x2="12"
      y2="-0.75"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 9.92969 1.19043)"
      stroke="#ABABAB"
      strokeWidth="1.5"
    />
    <line
      y1="-0.75"
      x2="12"
      y2="-0.75"
      transform="matrix(0.707107 0.707107 0.707107 -0.707107 1.44531 0.0766602)"
      stroke="#ABABAB"
      strokeWidth="1.5"
    />
  </svg>
);

const IconSave = (props) => (
  <svg
    width="17"
    height="14"
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.6679 13.1729C6.34872 13.1729 6.04155 13.0464 5.81481 12.8196L0.990032 7.99483C0.518948 7.52347 0.518948 6.76002 0.990032 6.28893C1.4614 5.81785 2.22485 5.81785 2.69593 6.28893L6.59725 10.1902L14.7766 0.59627C15.2088 0.0900011 15.9698 0.0288466 16.4772 0.460837C16.984 0.893106 17.0446 1.6546 16.6126 2.16143L7.58577 12.749C7.3674 13.005 7.05214 13.1583 6.71565 13.1717C6.69973 13.1723 6.68381 13.1729 6.6679 13.1729Z"
      fill="#BEC7DC"
    />
  </svg>
);

const IconRemove = (props) => (
  <svg
    width="13"
    height="15"
    viewBox="0 0 13 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.82599 2.32058H4.20099V1.94558C4.20099 1.44978 4.60292 1.04785 5.09872 1.04785H7.64418C8.13998 1.04785 8.5419 1.44978 8.5419 1.94558V2.32058H8.9169H12.0987C12.2431 2.32058 12.3601 2.43759 12.3601 2.58194V3.85467C12.3601 3.99902 12.2431 4.11603 12.0987 4.11603H11.4624H11.0874V4.49103V13.4001C11.0874 13.8959 10.6854 14.2979 10.1896 14.2979H2.55327C2.05747 14.2979 1.65554 13.8959 1.65554 13.4001V4.49103V4.11603H1.28054H0.644176C0.499829 4.11603 0.382812 3.99902 0.382812 3.85467V2.58194C0.382812 2.4376 0.499829 2.32058 0.644176 2.32058H3.82599ZM4.46236 5.38876C3.9038 5.38876 3.45099 5.84156 3.45099 6.40012V11.491C3.45099 12.0496 3.9038 12.5024 4.46236 12.5024C5.02092 12.5024 5.47372 12.0496 5.47372 11.491V6.40012C5.47372 5.84156 5.02092 5.38876 4.46236 5.38876ZM8.28054 5.38876C7.72198 5.38876 7.26918 5.84156 7.26918 6.40012V11.491C7.26918 12.0496 7.72198 12.5024 8.28054 12.5024C8.8391 12.5024 9.2919 12.0496 9.2919 11.491V6.40012C9.2919 5.84156 8.8391 5.38876 8.28054 5.38876Z"
      stroke="#BEC7DC"
      strokeWidth="0.75"
    />
  </svg>
);

/**
 * Identifica as feiçoes contidas em todas as camadas importadas ou do
 * catalogo de camadas numa coordenada especifica, que é determinada
 * através do clique no mapa na região desejada.
 *
 * Usando o getFeatureInfo em camadas WMS, e os dados contidos no GeoJson em camadas vetoriais.
 *
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação
 * @param {boolean} setIsActive Seta o estado
 * @param {*} props Resto
 * @returns Retorna uma tabela na parte inferior da tela com as feiçoes de acordo
 * com as camadas importadas e o local selecionado.
 */
export const IdentifyFeatureCoordinates = ({
  mapContext,
  isActive,
  setIsActive,
  ...props
}) => {
  const [latlngMarker, setLatLngMarker] = useState(null);
  const [foundData, setFoundData] = useState(null);
  const [cursor, setCursor] = useState(DarkBlueMarker);
  const [searchingData, setSearchingData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [saveModalOpen, setSaveModalOpen] = useState(false);
  const { setBottomPanelIsOpen } = mapContext;
  const [x, setX] = useState(null);
  const [y, setY] = useState(null);
  const [reload, setReload] = useState(false);

  const [toolOptionsState, toolOptionsDispatch] = useReducer(
    // Reducer para opções de ferramentas
    toolOptionsReducer, // Reducer para opções de ferramentas
    initialToolOptionsState //
  );
  const saveAsLayer = useSaveAsLayer();
  
  const { layers, map, setLoadingInMap } = useMap();

  const formik = useFormik({
    initialValues: {
      layerName: '',
      layerStyle: null,
    },
    validationSchema: Yup.object().shape({
      layerName: Yup.string().required('Campo obrigatório'),
    }),
    onSubmit: (values) => {
      saveAsLayer(values.layerName, values.layerStyle,latlngMarker, setSaveModalOpen, resetForm, hadleRemoveMarker, Layer);
    },
  });
  const { resetForm } = formik;

  const hadleRemoveMarker = useCallback(() => {
    setX('');
    setY('');
    setLatLngMarker('');
    setFoundData('');
    setCursor('crosshair');
    setIsActive();
    setShowModal(false);
  }, [setIsActive]);

  
  /**
   * getFromWms
   *
   * @param {array} wmsLayers
   * @param {number} x
   * @param {number} y
   * @param {function} mapSize
   * @param {*} bboxString
   *
   * @returns
   */
  const getFromWms = async (wmsLayers, x, y, mapSize, bboxString) => {
    if (wmsLayers.length > 0) {
      let promises = [];
      let featuresInfo = {};
      wmsLayers.forEach((v) => {
        let layerNames = Object.keys(v.layers);
        featuresInfo = { ...featuresInfo, ...v.layers };
        let getFeatureInfoParams = {
          service: 'WMS',
          version: '1.1.1',
          request: 'GetFeatureInfo',
          layers: layerNames.join(','),
          styles: '',
          srs: 'EPSG:4326',
          bbox: bboxString,
          width: mapSize.x,
          height: mapSize.y,
          query_layers: layerNames.join(','),
          info_format: 'application/json',
          tiled: 'true',
          x,
          y,
          feature_count: 50,
          buffer: 1,
        };

        promises.push(
          axios(v.baseUrl, {
            params: getFeatureInfoParams,
          })
            .then(({ data }) => ({
              data,
              raster: v.raster,
              id: v.raster ? layerNames[0] : null,
            }))
            .catch((e) => {
              console.error(
                'Erro ao indentificar camada(s):',
                layerNames.join(','),
                e
              );
              return null;
            })
        );
      });

      return await Promise.all(promises).then((values) => {
        //Obtém os nomes das camadas sem o workspace, para se igualar a resposta
        let layerNames = Object.keys(featuresInfo).reduce(
          (ac, k) => ({ ...ac, [k.split(':')[1]]: k }),
          {}
        );
        values.forEach((result) => {
          if (result && result.data.features?.length > 0) {
            result.data.features.forEach((feature) => {
              let layerName = result.raster
                ? result.id.split(':')[1]
                : feature.id.split('.')[0];
              if (featuresInfo[layerNames[layerName]]) {
                let featureProperties = feature.properties;
                let featureBbox = featureProperties.bbox || feature.bbox;
                if (featureBbox) {
                  if (
                    ['Point', 'MultiPoint'].includes(
                      featuresInfo[layerNames[layerName]].layer.dataType
                    )
                  )
                    featureProperties.bbox = L.latLng([
                      featureBbox[1],
                      featureBbox[0],
                    ]);
                  else
                    featureProperties.bbox = L.latLngBounds(
                      [featureBbox[1], featureBbox[0]],
                      [featureBbox[3], featureBbox[2]]
                    );
                }

                if (featuresInfo[layerNames[layerName]].featureInfo) {
                  featuresInfo[layerNames[layerName]].featureInfo.push(
                    featureProperties
                  );
                } else
                  featuresInfo[layerNames[layerName]].featureInfo = [
                    featureProperties,
                  ];
              } else {
                console.error(
                  'Falha ao listar propriedades da camada: ',
                  layerName,
                  layerNames
                );
              }
            });
          }
        });
        return Object.keys(featuresInfo).map((k) => featuresInfo[k]);
      });
    }
    return [];
  };

  const getFromGeoJson = useCallback((vectorLayers, latlng, layerPoint) => {
    let newFoundData = [];
    if (vectorLayers.length > 0) {
      // Realiza buffer na area clicada para garantir a seleção
      const bufferedMarker = turf.buffer(
        turf.point([latlng.lng, latlng.lat]),
        0.01,
        { units: 'meters' }
      );

      let bufferBbox = turf.bbox(bufferedMarker);
      bufferBbox = turf.bboxPolygon(bufferBbox);

      vectorLayers.forEach((vl) => {
        let layerData = {
          layer: vl,
          featureInfo: [],
        };

        vl.leafletLayer.eachLayer((feature) => {
          let featureBbox = feature.getBounds && feature.getBounds();
          featureBbox = featureBbox && [
            featureBbox.getSouthWest().lng,
            featureBbox.getSouthWest().lat,
            featureBbox.getNorthEast().lng,
            featureBbox.getNorthEast().lat,
          ];
          if (
            turf.booleanIntersects(
              bufferBbox,
              featureBbox ? turf.bboxPolygon(featureBbox) : feature.feature
            )
          ) {
            turf.booleanIntersects(feature.feature, bufferBbox) &&
              layerData.featureInfo.push({
                ...feature.feature.properties,
                bbox: feature.getBounds
                  ? feature.getBounds()
                  : feature.getLatLng(),
              });
          }
        });

        newFoundData.push(layerData);
      });
    }
    return newFoundData;
  }, []);

  const getFeatureInfoByCoordinates = useCallback(
    async (latitude = 0, longitude = 0) => {
      if (toolOptionsState.type.value === 'UTM') {
        let convertedCoords = Coordinate.convertUTMtoDD(
          [longitude, latitude],
          toolOptionsState.timezone.value
        );
        [longitude, latitude] = convertedCoords;
      }

      if (
        latitude.toString().includes('°') &&
        longitude.toString().includes('°')
      ) {
        let coords = Coordinate.convertDMSToDD([longitude, latitude]);
        longitude = coords[0];
        latitude = coords[1];
      }

      if (!searchingData) {
        let latLng;
        let wmsLayers = [];
        let vectorLayers = [];
        let mapSize = map.getSize();
        let x = latitude;
        let y = longitude;

        setSearchingData(true);
        setLoadingInMap(true);

        latitude = latitude.toString().replace(',', '.');
        longitude = longitude.toString().replace(',', '.');

        let lat = parseFloat(latitude);
        let lng = parseFloat(longitude);
        let point = map.latLngToContainerPoint([lat, lng]);
        x = Math.floor(point.x);
        y = Math.floor(point.y);

        latLng = map.containerPointToLatLng([x, y]);

        if (!isNaN(lat) && !isNaN(lng)) {
          setLatLngMarker([lat, lng]);
        }

        let electivesLayers = layers.filter((l) => l.isSelected);
        electivesLayers =
          electivesLayers.length > 0
            ? electivesLayers.filter((l) => l.visible)
            : layers.filter((l) => l.visible);

        electivesLayers.forEach((l) => {
          let bounds = l.getBoundingBox();
          bounds = bounds
            ? L.latLngBounds(
                [bounds.miny, bounds.minx],
                [bounds.maxy, bounds.maxx]
              )
            : map.getBounds();
          if (bounds.contains(latLng)) {
            if (l.getService() === 'WMS') {
              let baseUrl = l.getServiceLink();
              let added = false;
              wmsLayers.forEach((v) => {
                if (
                  !added &&
                  !v.raster &&
                  l.dataType?.toUpperCase() !== 'RASTER'
                ) {
                  if (
                    v.baseUrl === baseUrl &&
                    !v.layers[l.getLayerNameParam()]
                  ) {
                    v.layers[l.getLayerNameParam()] = { layer: l };
                    added = true;
                  } else if (
                    v.baseUrl === baseUrl &&
                    v.layers[l.getLayerNameParam()]
                  ) {
                    added = true;
                  }
                }
              });
              if (!added)
                wmsLayers.push({
                  baseUrl,
                  layers: { [l.getLayerNameParam()]: { layer: l } },
                  raster: l.dataType?.toUpperCase() === 'RASTER',
                });
            } else if (
              l.getService() === 'WFS' ||
              l.type === 'importada' ||
              l.type === 'criada'
            ) {
              vectorLayers.push(l);
            }
          }
        });

        let dataFromGeoJson = getFromGeoJson(
          vectorLayers,
          latLng,
          map.latLngToLayerPoint(latLng)
        );

        // Realiza um buffer na coordenada para conseguir obter um bound box
        let bufferedMarker = turf.buffer(
          turf.point([latLng.lng, latLng.lat]),
          0.01,
          { units: 'meters' }
        );
        let bboxBufferBbox = turf.bbox(bufferedMarker);
        bboxBufferBbox = turf.bboxPolygon(bboxBufferBbox);
        let dataFromWms = await getFromWms(
          wmsLayers,
          x,
          y,
          mapSize,
          bboxBufferBbox.bbox.toString()
        );
        setFoundData([...dataFromGeoJson, ...dataFromWms]);
        setSearchingData(false);
        setLoadingInMap(false);
      }
    },
    [
      toolOptionsState,
      searchingData,
      map,
      setLoadingInMap,
      layers,
      getFromGeoJson,
    ]
  );

  const defineCursor = useCallback(
    (preset = 'auto') => {
      if (preset !== 'auto') {
        const cursors = {
          blue: BlueMarker,
          orange: OrangeMarker,
          darkBlue: DarkBlueMarker,
        };
        setCursor(cursors[preset]);
      } else {
        let haveData = false;
        foundData &&
          foundData.forEach((v) => {
            if (v.featureInfo && v.featureInfo.length > 0) haveData = true;
          });
        setCursor(
          foundData !== null
            ? haveData
              ? BlueMarker
              : OrangeMarker
            : DarkBlueMarker
        );
      }
    },
    [foundData]
  );

  useEffect(() => {
    if (isActive) {
      if (!showModal) {
        setShowModal(false);
      }
    } else {
      setShowModal(false);
      //reomver marcador do mapa
      if (map) {
        map.eachLayer((layer) => {
          if (layer.options.icon) {
            map.removeLayer(layer);
          }
        });
      }
      // fechar tabela de atributos
      setBottomPanelIsOpen(false);
    }
  }, [defineCursor, isActive, map, setBottomPanelIsOpen, showModal]);

  useEffect(() => {
    if (foundData) {
      setBottomPanelIsOpen(
        true,
        'Identificar Feição',
        <AttributeTable
          dataTabs={foundData}
          map={map}
          changeCursor={defineCursor}
        />
      );
    } else setBottomPanelIsOpen(false);
    setSearchingData(false);
    setLoadingInMap(false);
  }, [foundData, setBottomPanelIsOpen, map, defineCursor, setLoadingInMap]);

  // Adiciona o marcador no mapa
  useEffect(() => {
    let marker;
    if (latlngMarker) {
      var myIcon = L.icon({
        iconUrl: cursor,
        iconSize: [27, 33],
        iconAnchor: [13, 28],
        popupAnchor: [-3, -76],
      });
      marker = L.marker(latlngMarker, { icon: myIcon }).addTo(map);
    }
    return () => marker && marker.remove();
  }, [latlngMarker, map, cursor]);

  const validateCoordinate = useCallback(
    (x, y) => {
      // Verificar se os campos estão preenchidos
      if (x.trim() === '' || y.trim() === '') {
        return false;
      }

      const minDigitos = 3;
      if (x.length < minDigitos || y.length < minDigitos) {
        return false;
      }

      if (toolOptionsState.type.value === 'DD') {
        x = x.replace(',', '.');
        y = y.replace(',', '.');

        if (isNaN(x) || isNaN(y)) {
          return false;
        }
      }

      if (toolOptionsState.type.value === 'UTM') {
        if (
          !toolOptionsState.timezone ||
          toolOptionsState.timezone.value === ''
        ) {
          return false;
        }
      }

      // Outras verificações específicas podem ser adicionadas aqui, como intervalo válido, formato esperado, etc.
      return true;
    },
    [toolOptionsState.type.value, toolOptionsState.timezone]
  );

  const handleCoordinateChange = useCallback(
    (coordinateType, newValue) => {
      const formattedValue = newValue.toString();
      if (coordinateType === 'x') {
        setX(formattedValue);
        if (formattedValue && y && validateCoordinate(formattedValue, y)) {
          getFeatureInfoByCoordinates(formattedValue, y);
        } else {
          // Exibir mensagem de erro ou tomar alguma outra ação quando as coordenadas forem inválidas
        }
      } else if (coordinateType === 'y') {
        setY(formattedValue);
        if (x && formattedValue && validateCoordinate(x, formattedValue)) {
          getFeatureInfoByCoordinates(x, formattedValue);
        } else {
          // Exibir mensagem de erro ou tomar alguma outra ação quando as coordenadas forem inválidas
        }
      }
    },
    [getFeatureInfoByCoordinates, validateCoordinate, x, y]
  );

  useEffect(() => {
    if (reload) {
      handleCoordinateChange('y', y);
    }
    setReload(false);
  }, [handleCoordinateChange, y, reload]);

  const handleXChange = useCallback(
    (e) => {
      handleCoordinateChange('x', e.target.value);
    },
    [handleCoordinateChange]
  );

  const handleYChange = useCallback(
    (e) => {
      handleCoordinateChange('y', e.target.value);
    },
    [handleCoordinateChange]
  );

  /**
   * Reseta formik para estado inicial e fecha modal
   */
  const handleCloseSaveModal = useCallback(() => {
    resetForm();
    setSaveModalOpen(false);
    setBottomPanelIsOpen(false);
  }, [resetForm, setBottomPanelIsOpen]);

  const handleSelectChange = (e) => {    
    setX('');
    setY('');    
  };

  return (
    <>
      <ButtonTooltip
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: 'none',
          width: '35px',
          height: '40px',
        }}
        tooltip={IdentifyFeatureCoordinates.properties.alias}
        description={IdentifyFeatureCoordinates.properties.description}
        activeWithBgColor
        onClick={() => {
          setShowModal(true);
          setIsActive();
          setX('');
          setY('');
        }}
        active={isActive}
      >
        <Icon width="24" height="24" />
      </ButtonTooltip>

      {showModal && (
        <CustomDraggable classeName=".input-text">
          <ModalContainer style={{ zIndex: 1700 }}>
            <div className="modal-int">
              <div className="wrap-title"  style={{
                cursor: 'move',
              }}>
                <span>Identificar Feição por Coordenadas</span>
                <div
                  className="close-modal"
                  onClick={() => {
                    setShowModal(false);
                    hadleRemoveMarker();
                  }}
                >
                  <IconClose width="24" height="24" />
                </div>
              </div>
              <div className="form-group">
                <div className="selects_grid input-text">
                  <FormControl variant="outlined" margin="dense">
                    {(!toolOptionsState.type || toolOptionsState.type.csv) && (
                      <InputLabel id="coord-type-label" shrink={false}>
                        {toolOptionsState.type.csv
                          ? toolOptionsState.type.label
                          : 'Tipo'}
                      </InputLabel>
                    )}
                    <SelectMui
                      labelId="coord-type-label"
                      value={toolOptionsState.type}
                      onChange={(e) => {
                        handleSelectChange(e);
                        toolOptionsDispatch({
                          type: 'setType',
                          payload: e.target.value,
                        });
                      }}
                      MenuProps={{ style: { zIndex: 1700 } }}
                    >
                      {typeOptions.map((t, i) => (
                        <MenuItem
                          value={t}
                          key={i}
                          style={{
                            fontSize: '14px',
                            fontFamily: 'Roboto',
                            fontStyle: 'normal',
                            fontWeight: '400',
                            lineHeight: 'normal',
                          }}
                        >
                          {t.label}
                        </MenuItem>
                      ))}
                    </SelectMui>
                  </FormControl>

                  <FormControl variant="outlined" margin="dense">
                    {!toolOptionsState.timezone && (
                      <InputLabel id="coord-fuso" shrink={false}>
                        Fuso
                      </InputLabel>
                    )}
                    <SelectMui
                      className="input-text"
                      labelId="coord-fuso"
                      value={toolOptionsState.timezone}
                      onChange={(e) => {
                        toolOptionsDispatch({
                          type: 'setTimezone',
                          payload: e.target.value,
                        });
                        setReload(!reload);
                      }}
                      disabled={!toolOptionsState.timezoneIsEnabled}
                      MenuProps={{ style: { zIndex: 1700 } }}
                    >
                      {timezoneOptions.map((t, i) => (
                        <MenuItem
                          value={t}
                          key={i}
                          style={{
                            fontSize: '14px',
                            fontFamily: 'Roboto',
                            fontStyle: 'normal',
                            fontWeight: '400',
                            lineHeight: 'normal',
                          }}
                        >
                          {t.label}
                        </MenuItem>
                      ))}
                    </SelectMui>
                  </FormControl>
                </div>

                <div
                  className={`coordinatesCreated ${
                    toolOptionsState.type.value === 'UTM' && 'reverse'
                  }`}
                >
                  <MaskedTextField
                    id="masked-input"
                    className="input-text"
                    variant="outlined"
                    size="small"
                    value={x}
                    mask={toolOptionsState.type.mask.lat}
                    placeholder={toolOptionsState.type.fieldLabels.lat}
                    guide={false}
                    keepCharPositions={true}
                    onChange={(e) => {
                      handleXChange(e);
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        {toolOptionsState.type.endAdornment}
                      </InputAdornment>
                    }
                  />

                  <MaskedTextField
                    id="masked-input"
                    className="input-text"
                    variant="outlined"
                    size="small"
                    value={y}
                    mask={toolOptionsState.type.mask.lng}
                    placeholder={toolOptionsState.type.fieldLabels.lng}
                    guide={false}
                    keepCharPositions={true}
                    onChange={(e) => {
                      handleYChange(e);
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        {toolOptionsState.type.endAdornment}
                      </InputAdornment>
                    }
                  />
                </div>
                <Groupbutton>
                  <div />
                  <div className="wrap-buttons">
                    <button
                      disabled={x && y ? false : true}
                      onClick={() => {
                        hadleRemoveMarker();
                        setShowModal(false);
                      }}
                    >
                      <IconRemove width="24" height="24" />
                    </button>
                    <button
                      disabled={x && y ? false : true}
                      onClick={() => {
                        if (!x || !y) {
                          alert('Informe os valores de X e Y');
                          return false;
                        }
                        setSaveModalOpen(true);
                        setShowModal(false);
                      }}
                    >
                      <IconSave width="24" height="24" />
                    </button>
                  </div>
                </Groupbutton>
              </div>
            </div>
          </ModalContainer>
        </CustomDraggable>
      )}

      <CustomModalSaveAsLayer
        title="Salvar Camada"
        saveModalOpen={saveModalOpen}
        handleCloseSaveModal={handleCloseSaveModal}
        formik={formik}
        SliderColorPicker={<SliderColorPicker
          geometryType="Point"
          autoSelect={false}
          selectedSymbology={formik.values.layerStyle}
          onSelect={(style) => formik.setFieldValue('layerStyle', style)}
        />}
      />
    </>
  );
};

IdentifyFeatureCoordinates.properties = {
  id: 'CPN-TB-A-IDENTIFY-COORDINATES-FEATURE',
  alias: 'Identificar feição por coordenadas',
  description:
    'Realiza a identificação de feições com seus atributos ao inserir um par de coordenadas.',
};

export default IdentifyFeatureCoordinates;
